export const FETCH_BANK_ACCOUNTS_FAILED = 'FETCH_BANK_ACCOUNTS_FAILED'
export const FETCH_BANK_ACCOUNTS_START = 'FETCH_BANK_ACCOUNTS_START'
export const FETCH_BANK_ACCOUNTS_SUCCESS = 'FETCH_BANK_ACCOUNTS_SUCCESS'
export const UPDATE_BANK_ACCOUNTS_START = 'UPDATE_BANK_ACCOUNTS_START'
export const UPDATE_BANK_ACCOUNTS_FAILED = 'UPDATE_BANK_ACCOUNTS_FAILED'
export const UPDATE_BANK_ACCOUNTS_SUCCESS = 'UPDATE_BANK_ACCOUNTS_SUCCESS'
export const DELETE_BANK_ACCOUNTS_START = ' DELETE_BANK_ACCOUNTS_START'
export const DELETE_BANK_ACCOUNTS_FAILED = ' DELETE_BANK_ACCOUNTS_FAILED'
export const DELETE_BANK_ACCOUNTS_SUCCESS = ' DELETE_BANK_ACCOUNTS_SUCCESS'
